import { TagInfo } from "../../interfaces";
import { TAG_CANONICAL_NAMES } from "../../utils";
import { EntityType } from "./types";

export const proposalDataMassager = (data: any[]) => {
  return data.map((d) => ({
    ...d,
    title: d.sequence_id,
    description: d?.proposal_name ?? "",
    priority: d.tags_info?.find(
      (t: TagInfo) =>
        t.tag_group_canonical_name === TAG_CANONICAL_NAMES.proposal_priority
    ),
  }));
};

export const projectDataMassager = (data: any[]) => {
  return data.map((d) => ({
    ...d,
    title: d.sequence_id,
    description: d?.project_name ?? "",
    priority: d.tags_info?.find(
      (t: TagInfo) =>
        t.tag_group_canonical_name === TAG_CANONICAL_NAMES.project_priority
    ),
  }));
};

export const productDataMassager = (data: any[]) => {
  return data.map((d) => ({
    ...d,
    title: d.sequence_id,
    description: d?.product_name ?? "",
    priority: d.tags_info?.find(
      (t: TagInfo) =>
        t.tag_group_canonical_name === TAG_CANONICAL_NAMES.product_priority
    ),
  }));
};

export const quoteDataMassager = (data: any[]) => {
  return data.map((d) => ({
    ...d,
    title: `${d.sequence_id}-r${d.version}`,
    description: d.name,
    priority: d.tags_info?.find(
      (t: TagInfo) =>
        t.tag_group_canonical_name === TAG_CANONICAL_NAMES.quote_priority
    ),
  }));
};

export const taskDataMassager = (data: any[]) => {
  return data.map((d) => ({
    ...d,
    title: d.sequence_id,
    description: d.name,
    priority: d.tags_info?.find(
      (t: TagInfo) =>
        t.tag_group_canonical_name === TAG_CANONICAL_NAMES.task_priority
    ),
  }));
};

export const documentDataMassager = (data: any[]) => {
  return data.map((d) => ({
    ...d,
    title: d.sequence_id,
    description: d.file_name,
    priority: d.tags_info?.find(
      (t: TagInfo) =>
        t.tag_group_canonical_name === TAG_CANONICAL_NAMES.doc_priority
    ),
  }));
};

export const massageData = (type: EntityType, data: any[]) => {
  let result = [];
  switch (type) {
    case "proposal":
      result = proposalDataMassager(data);
      break;
    case "project":
      result = projectDataMassager(data);
      break;
    case "product":
      result = productDataMassager(data);
      break;
    case "quote":
      result = quoteDataMassager(data);
      break;
    case "taskManager":
      result = taskDataMassager(data);
      break;
    case "document":
      result = documentDataMassager(data);
      break;
    default:
      result = [];
  }
  return result;
};

export const PUBLISHABLE: Record<EntityType, boolean> = { quote: true, pricing: true, product: false, proposal: false, project: false, document: true, taskManager: false };
